import { post, get, getFrom } from "@/axios";
//创建包裹异常流程
export const pkgSplit = function (params) {
  return post("/wms/pkg/pkgSplit", params);
};

//异常列表分页
export const abnormalPage = function (params) {
  return post("/wms/flow/page", params);
};
//异常处理流程
export const dealFlow = function (params) {
  return post("/wms/flow/dealFlow", params);
};
//库内异常处理
export const wareDealFlow = function (params) {
  return post("/wms/flow/wareDealFlow", params);
};
//批次包详情
export const pkgDetail = function (params) {
    return get('/wms/pkg/pkgDetail', params)
}
// 详细检品操作日志
export const pkgDetailLog = function (params) {
  return get('/wms/pkg/checkingRecord', params)
}




//库内异常分页
export const innerExceptionPage = function (params) {
  return post("/wms/innerException/page", params);
};
//库内异常处理
export const deal = function (params) {
  return post("/wms/innerException/deal", params);
};

//创建库内异常
export const createInnerException = function (params) {
  return post("/wms/innerException/create", params);
};

//编辑责任人
export const editAbnormalCreaterApi = function (params) {
  return post("/wms/innerException/edit", params);
};

//不可返品次品转正品

//列表分页
export const regularizationPage = function (params) {
  return post("/wms/regularization/page", params);
};
//获取操作详细
export const regularizationDetail = function (params) {
  return get("/wms/regularizationOperation/getOperationDetail", params);
};
//生成拣货任务
export const regularizationCreateTask = function (params) {
  return post("/wms/regularization/batchCreateTask", params);
};
//生成拣货任务
export const regularizationPrint = function (params) {
  return get("/wms/regularization/printBatch", params);
};


//异常包裹分页
export const abnormalPackage = function (params) {
  return post("/wms/flow/sign/page", params);
};
//异常操作日志
export const recordInfo = function (params) {
  return get("/wms/flow/operate/record/info", params);
};
//异常列表分页数量统计
export const abnormalCount = function (params) {
  return post("/wms/flow/page/count", params);
};
//异常签收包裹分页数量统计接口
export const abnormalPackageCount = function (params) {
  return post("/wms/flow/sign/page/count", params);
};

